var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSurvey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 183,
    height: 136,
    viewBox: "0 0 183 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M182.75 25.8862H0.5V278.985H182.75V25.8862Z",
    fill: "#037DBA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.431 27.7506H2.81873V275.256H180.431V27.7506Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.912 21.2157H47.8015V42.6662H135.912V21.2157Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8569 0.25C85.0538 0.25 79.5399 5.92725 79.5399 12.9283C79.5399 19.9293 85.0538 25.6065 91.8569 25.6065C98.66 25.6065 104.174 19.9293 104.174 12.9283C104.174 5.92725 98.66 0.25 91.8569 0.25ZM91.8569 20.2416C87.8409 20.3488 84.4973 17.1606 84.3953 13.124C84.2933 9.08749 87.4606 5.72682 91.4766 5.62428C95.4926 5.51707 98.8362 8.70528 98.9382 12.7418C98.9382 12.8024 98.9428 12.8677 98.9428 12.9283C98.9892 16.9135 95.8219 20.181 91.8569 20.2416Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.985 21.2251H48.729V41.734H134.985V21.2251Z",
    fill: "#037DBA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8569 1.18224C85.1976 1.18224 79.7996 6.60778 79.7996 13.3012C79.7996 19.9945 85.1976 25.4201 91.8569 25.4201C98.5162 25.4201 103.914 19.9945 103.914 13.3012C103.914 6.60778 98.5162 1.18224 91.8569 1.18224ZM91.8569 20.2928C88.0171 20.2928 84.9008 17.1606 84.9008 13.3012C84.9008 9.44175 88.0171 6.30947 91.8569 6.30947C95.6966 6.30947 98.813 9.44175 98.813 13.3012C98.813 17.1606 95.6966 20.2928 91.8569 20.2928Z",
    fill: "#037DBA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1927 67.8363H11.166V106.058H49.1927V67.8363Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8015 69.2347H12.5573V104.659H47.8015V69.2347Z",
    fill: "#037DBA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.296 80.1696H70.9885V83.5583H119.296V80.1696Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.752 85.2549H70.9885V88.6436H150.752V85.2549Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.136 90.3356H70.9885V93.7242H145.136V90.3356Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1799 84.8354L28.5795 90.7364L37.6456 77.3357L40.8454 80.0158L28.5795 96.0967L19.5134 85.9121L22.1799 84.8354Z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2233 85.0825L28.7882 90.2097L36.6718 78.5569L39.4542 80.8875L28.7882 94.8709L20.9046 86.0147L23.2233 85.0825Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 91.8568,
    y1: 42.6662,
    x2: 91.8568,
    y2: 21.2157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 91.8569,
    y1: 25.6065,
    x2: 91.8569,
    y2: 0.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 30.1794,
    y1: 106.058,
    x2: 30.1794,
    y2: 67.8363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 30.1794,
    y1: 96.0967,
    x2: 30.1794,
    y2: 77.3357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 182.25,
    height: 278.735,
    fill: "white",
    transform: "translate(0.5 0.25)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurvey);
export default __webpack_public_path__ + "static/media/survey.33adb037.svg";
export { ForwardRef as ReactComponent };